import { FC } from 'react'
import { DetailField, DetailFields, DetailPanel, DetailSection } from '../../../../../../components'
import { AtendimentoGestao } from '../../core/_models'
import { useT } from '_metronic/i18n/Metronici18n'
import { formatBoolean, formatDateTime, formatTimeDuration } from '_metronic/helpers'

type IAtendimentoExtra = {
  isLoading?: boolean
  atendimento?: AtendimentoGestao
}

// Sem valor, o campo mostra "Não informado" (os helpers devolveriam "-").
const dataHora = (value?: string) => (value ? formatDateTime(value) : undefined)
const duracao = (value?: number) =>
  value === undefined || value === null ? undefined : formatTimeDuration(value)

export const AtendimentoGestaoExpandedRow: FC<IAtendimentoExtra> = ({ isLoading, atendimento }) => {
  const { t } = useT()

  return (
    <DetailPanel isLoading={isLoading} loadingLabel='Carregando detalhes do atendimento…'>
      {!atendimento ? (
        <span className='text-muted'>Sem informações de gestão</span>
      ) : (
        <>
          <DetailSection title='Atendimento'>
            <DetailFields>
              <DetailField
                label={t('empresa.label')}
                value={atendimento.empresa?.nomeFantasia || atendimento.empresa?.nome}
              />
              <DetailField label={t('unidade.label')} value={atendimento.unidade?.nome} />
              <DetailField
                label={t('profissional_inicial.label')}
                value={atendimento.responsavelInicial?.nome}
              />
              <DetailField
                label={t('tipoAtendimento.label')}
                value={atendimento.tipoAtendimento || atendimento.tipo}
              />
              <DetailField
                label={t('modalidade.label')}
                value={atendimento.modalidadeAtendimento || atendimento.modalidade}
              />
              <DetailField
                label={t('retorno.label')}
                value={
                  atendimento.retorno === undefined ? undefined : formatBoolean(atendimento.retorno)
                }
              />
            </DetailFields>
          </DetailSection>

          <DetailSection title='Linha do tempo'>
            <DetailFields>
              <DetailField
                label={t('inicio_triagem.label')}
                value={dataHora(atendimento.inicioTriagem)}
              />
              <DetailField
                label={t('termino_triagem.label')}
                value={dataHora(atendimento.terminoTriagem)}
              />
              <DetailField
                label={t('paciente_online.label')}
                value={dataHora(atendimento.dataPacienteOnline)}
              />
              <DetailField
                label={t('medico_online.label')}
                value={dataHora(atendimento.dataMedicoOnline)}
              />
              <DetailField
                label={t('paciente_offline.label')}
                value={dataHora(atendimento.dataPacienteOffline)}
              />
              <DetailField
                label={t('medico_offline.label')}
                value={dataHora(atendimento.dataMedicoOffline)}
              />
            </DetailFields>
          </DetailSection>

          <DetailSection title='Tempos'>
            <DetailFields>
              <DetailField label={t('espera.label')} value={duracao(atendimento.tempoEspera)} />
              <DetailField label={t('triagem.label')} value={duracao(atendimento.tempoTriagem)} />
              <DetailField
                label={t('atraso_consulta.label')}
                value={duracao(atendimento.tempoAtrasoConsulta)}
              />
              <DetailField
                label={t('atraso_medico.label')}
                value={duracao(atendimento.tempoAtrasoMedico)}
              />
              <DetailField
                label={t('espera_atendimento.label')}
                value={duracao(atendimento.tempoEsperaAtendimento)}
              />
              <DetailField label={t('consulta.label')} value={duracao(atendimento.tempoConsulta)} />
            </DetailFields>
          </DetailSection>
        </>
      )}
    </DetailPanel>
  )
}
